"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 6c-2.2367 0-4.0499 1.8132-4.0499 4.0499 0 2.2417 1.1054 4.196 2.2967 5.6418.6492.7878 1.3019 1.3969 1.7532 1.7814.4513-.3845 1.104-.9936 1.7532-1.7814 1.1913-1.4458 2.2967-3.4001 2.2967-5.6418C16.05 7.8132 14.2368 6 12.0001 6zM8.7034 16.9635c-1.3337-1.6186-2.7532-4.014-2.7532-6.9136C5.9502 6.7086 8.6588 4 12.0001 4S18.05 6.7086 18.05 10.0499c0 2.8996-1.4195 5.295-2.7532 6.9136C14.3297 18.1372 13.2084 19.0915 12 20c-1.2045-.9061-2.3313-1.8649-3.2966-3.0365z"
  }), _react.default.createElement("path", {
    d: "M14 10c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2z"
  })];
};

exports.default = _default;